<template>
  <div :class="`${$style.sign} ${hiddenTitle ? $style.hiddenTitle : ''}`">
    <header>
      <div @click="closePage">
        <i class="iconfont yw-xiangzuo"></i>
        <span>{{ '转区&转游福利' }}</span>
      </div>
    </header>
    <main>
      <p :class="$style.title">为了更好维护用户的游戏体验，本平台特别推出转区/转游服务！</p>
      <p :class="$style.subTitle">转区规则介绍：</p>
      <p>1.玩家在老区的真实充值金额额度（<span :class="$style.bl">{{ transferData.transArea }}%返利</span>）转移到下一个新区！</p>
      <p>2.新区充值后直接返利，最大上限不超过老区的累计真实充值金额！</p>
      <p :class="$style.red">注意：转区成功后，客服会封禁掉老区角色哦！</p>
      <p :class="$style.subTitle">转游规则介绍：</p>
      <p>1.玩家在老游戏的真实充值可<span :class="$style.bl">{{ transferData.transGame }}%额度（{{ transferData.transGame }}%返利）</span>转移到新游戏！</p>
      <p>2.新游戏充值后直接返利，最大上限不超过老游戏的累计真实充值金额的<span :class="$style.yl">100%！</span></p>
      <p :class="$style.red">注意：转游成功后，客服会封禁掉老游戏角色哦！</p>
      <p :class="$style.subTitle">参与方式：</p>
      <p>{{ `点击下方链接，一键联系客服小姐姐转区&转游` }}</p>
      <p :class="$style.contact" @click="showKf">点击联系客服小姐姐了解详情</p>
      <p :class="$style.title" v-if="transferData.imagesOne || transferData.imagesTwo">图文教程：</p>
      <img :src="transferData.imagesOne" alt="" />
      <img :src="transferData.imagesTwo" alt="" />
    </main>
  </div>
</template>

<script>
import { inithandler } from '@/bridge/jsBridge';
import { CDN_URL_1 } from '@/config';
import { signInEventTrack, getUserInfo, onGoBack, setPageTitle, setPageTitleColor, setPageTitleBgColor, setRightTxt, clickRightTxt } from '@/bridge/AppJsBridge';
import { transferApi } from '@/apis/box';
import { versionCompare } from '@/libs/utils'

export default {
  name: '',
  data() {
    return {
      cdnLink: CDN_URL_1,
      deviceInfo: {},
      userInfo: {},
      transferData: {},
      version: '',
      hiddenTitle: false,
    };
  },
  created() {
    inithandler();

    this.version = this.$route.query.version || '';
    if (versionCompare(this.version, '1.2.0')) {
      this.hiddenTitle = true;
    }

    setPageTitle('转区&转游福利');
    setPageTitleColor('#FFFFFF');
    setPageTitleBgColor('#FFC24B');
  },
  mounted() {
    this.insert53Code();
    this.getData()
  },
  components: {},
  methods: {
    async getData() {
      const r = await transferApi();
      this.transferData = r.data
    },
    closePage() {
      onGoBack();
    },
    showKf() {
      window.location.replace('https://wpa1.qq.com/gaZhL4kC?_type=wpa&qidian=true')

      
    },
    bridgeListener() {
      signInEventTrack(data => {
        this.deviceInfo = JSON.parse(data);
        // this.eventTrack('ENTER_ACTIVE_PAGE');
      });
      getUserInfo(data => {
        this.userInfo = data;
        
      });
    },
    // 插入53在线客服代码
    insert53Code(username) {
      let _53code = document.createElement('script');
      let src = '//tb.53kf.com/code/code/7218fcbe99ccc9c959f32b5afc7eb38e4/8';
      src = `${src}?u_cust_id=${username}&u_cust_name=${username}`;
      _53code.src = src;
      _53code.async = 'async';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(_53code, s);
    }
  }
};
</script>

<style lang="scss" module>
.sign {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  padding-top: 50px;
  padding-bottom: 80px;
  overflow: auto;
  &.hiddenTitle {
     padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 1;
    background: #ffc24b;
    color: #ffffff;
    font-size: 19px;
    padding: 14px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
    }
    > span {
      font-size: 16px;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  > main {
    font-size: 13px;
    color: #999999;
    padding: 18px 19px;
    line-height: 1.5;
    .title {
      color: #333333;
      font-size: 16px;
      line-height: 16.32px;
      margin-bottom: 10px;
    }
    .subTitle {
      color: #333333;
    }
    .yl,
    .contact {
      color: #0427ff;
    }
    .bl {
      color: #0427ff;
    }
    .red {
      color: #ea613c;
      margin-bottom: 20px;
    }
    .contact {
      text-decoration: underline;
      margin-bottom: 20px;
    }
    > img {
      width: 100%;
    }
  }
}
</style>
